import { useTranslation } from '@/i18n';

import AmbaImage from '../global/AmbaImage';

export type BadgeItemProps = {
  badgeImage: string;
  color: string;
  description: string;
  earned?: boolean;
  extraClass?: string;
  name: string;
  points?: number;
};

const BadgeItem = ({ badgeImage, color, description, earned, extraClass, name, points = 0 }: BadgeItemProps) => {
  const { t } = useTranslation('dashboard');

  return (
    <div
      className={`badgeContainer d-flex overflow-hidden ${extraClass}`}
      style={{
        filter: earned ? '' : 'grayscale(100%)',
      }}
    >
      <div className="badgeLogoWrapper w-25">
        <AmbaImage alt={description} extraClass={`badgeLogo ${earned ? 'earned' : ''}`} imageSrc={badgeImage} isLink={false} />
      </div>
      <div className="badgeInfo w-75 pt-1 ms-1">
        <div className="badgeTitle f-raleway-regular f-12">
          <span>{name}</span>
        </div>
        {points > 0 && (
          <div className="badgePoints f-raleway-bold f-12" style={{ color: color }}>
            <span>{t('sidebar.badgePoints', { count: points })}</span>
          </div>
        )}
      </div>
    </div>
  );
};

export default BadgeItem;
